import React from 'react'
import Bardata from "../../../../components/GCgraph/GcData"
import Header from '../Header/Header'
function GC() {
    return (<>
        <div>
        <Header label="GC"/>
            
        </div>
        <Bardata/>
        </>
    )
}

export default GC
